// TODO: move this to a more general checkout types
import { parseISO } from 'date-fns'

export type OrderDetailsDelivery = {
  start: Date
  end: Date
}

export type OrderDetails = Omit<Cinch.OrderDetailsResponse, '_rng' | '_id' | '_v' | '_ts'> & {
  createdAt: Date
  delivery?: OrderDetailsDelivery
}

const enrichDeliverySlot = (response: Cinch.OrderDetailsResponse) => {
  if (response.deliverySlot) {
    const [deliveryDate, deliveryTimes] = response.deliverySlot.split('_')
    const [deliveryTimeStart, deliveryTimeEnd] = deliveryTimes.split('-')
    return {
      start: parseISO(`${deliveryDate}T${deliveryTimeStart.length > 1 ? deliveryTimeStart : `0${deliveryTimeStart}`}`),
      end: parseISO(`${deliveryDate}T${deliveryTimeEnd.length > 1 ? deliveryTimeEnd : `0${deliveryTimeEnd}`}`),
    }
  }
  return undefined
}

export const enrichOrderDetailsResponse = (response: Cinch.OrderDetailsResponse): OrderDetails => {
  return {
    ...response,
    createdAt: response._ts ? parseISO(response._ts) : Date(), // TODO: Is this used anywhere
    delivery: { ...enrichDeliverySlot(response) }, // TODO: Can this not just be done on the page its needed?
  } as OrderDetails
}
